import AnnualLeave from "@/pages/AnnualLeave/AnnualLeave.vue";
import PageNotFound from "@/pages/PageNotFound/PageNotFound.vue";
import ProjectLeave from "@/pages/ProjectLeave/ProjectLeave.vue";
import ProjectLeaveDetail from "@/pages/ProjectLeaveDetail/ProjectLeaveDetail.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/pageLayout/PageLayout.vue";
import AbnormalCase from "../pages/AbnormalCase/AbnormalCase.vue";
import ChangePassword from "../pages/ChangePassword/ChangePassword.vue";
import CheckInOut from "../pages/CheckInOut/CheckinOut.vue";
import Configuration from "../pages/Configuration/Configuration.vue";
import DelegationManagement from "../pages/DelegationManagement/DelegationManagement.vue";
import Employee from "../pages/Employee/Employee.vue";
import ExplanationMangement from "../pages/ExplanationManagement/ExplanationMangement.vue";
import JobInfoHistory from "../pages/JobInfoHistory/JobInfoHistory.vue";
import Login from "../pages/Login/Login.vue";
import Logs from "../pages/Logs/Logs.vue";
import OnsiteManagement from "../pages/OnsiteManagement/OnsiteManagement.vue";
import OverTimeFlexibleDetail from "../pages/OverTimeFlexibleDetail/OverTimeFlexibleDetail.vue";
import OvertimeManagement from "../pages/OverTimeManagement/OverTimeManagement.vue";
// import Payroll from "../pages/Payroll/Payroll.vue";
import Report from "../pages/Report/Report.vue";
import TMSReport from "../pages/Report/TMSReport/TMSReport.vue";
import RequestManagement from "../pages/RequestManagement/RequestManagement.vue";
import Settings from "../pages/Settings/Settings.vue";
import SpecialExplanation from "../pages/SpecialExplanation/SpecialExplanation.vue";
import Timesheet from "../pages/Timesheet/Timesheet.vue";
import UpdateLeave from "../pages/UpdateLeave/UpdateLeave.vue";

import CreateEditWorkScheduleSetting from "@/pages/CreateEditWorkScheduleSetting/CreateEditWorkScheduleSetting.vue";
import PolicyConfig from "@/pages/PolicyConfig/PolicyConfig.vue";
import PolicyManagement from "@/pages/PolicyManagement/PolicyManagement.vue";
import PolicyManagementEmployeeHistory from "@/pages/PolicyManagementEmployeeHistory/PolicyManagementEmployeeHistory.vue";

import ReportMapping from "@/pages/ReportMapping/ReportMapping.vue";
import {
  ROUTER_PAGE_ABNORMAL_NOTIFICATION,
  ROUTER_PAGE_ANNUAL_LEAVE,
  ROUTER_PAGE_CHECKIN_CHECKOUT_time,
  ROUTER_PAGE_CONFIGURATION,
  ROUTER_PAGE_DELEGATION_MANAGEMENT,
  ROUTER_PAGE_EMPLOYEE_MANAGEMENT,
  ROUTER_PAGE_LEAVE_MANAGEMENT,
  ROUTER_PAGE_LOGIN,
  ROUTER_PAGE_LOGS,
  ROUTER_PAGE_ONSITE_MANAGEMENT,
  ROUTER_PAGE_OVERTIME_MANAGEMENT,
  ROUTER_PAGE_OVERTIME_MANAGEMENT_DETAIL,
  ROUTER_PAGE_PAGE_NOT_FOUND,
  ROUTER_PAGE_POLICY_CONFIG,
  ROUTER_PAGE_POLICY_CONFIG_CREATE,
  ROUTER_PAGE_POLICY_CONFIG_EDIT,
  ROUTER_PAGE_POLICY_MANAGEMENT,
  ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY,
  ROUTER_PAGE_POLICY_SETTINGS,
  ROUTER_PAGE_PROJECT_LEAVE,
  ROUTER_PAGE_PROJECT_LEAVE_DETAIL,
  ROUTER_PAGE_REPORT,
  ROUTER_PAGE_REPORT_CHECK_TIME,
  ROUTER_PAGE_REPORT_DETAIL,
  ROUTER_PAGE_REPORT_POLICY_MAPPING,
  ROUTER_PAGE_REPORT_SUMMARY,
  ROUTER_PAGE_REQUEST_MANAGEMENT,
  ROUTER_PAGE_SETTING,
  ROUTER_PAGE_SETTINGS,
  ROUTER_PAGE_SPECIAL_EXPLANATION,
  ROUTER_PAGE_TIMESHEET,
} from "@/utils";
import store from "../store/store";
Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.state.user.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.state.user.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: ROUTER_PAGE_LOGIN,
      component: Login,
      beforeEnter: ifNotAuthenticated,
      meta: {
        isIgnore: true,
      },
    },
    {
      path: "/change-password",
      component: ChangePassword,
    },
    {
      path: "/update-leave",
      component: UpdateLeave,
    },
    {
      path: "/",
      name: "layout",
      redirect: "/timesheet",
      component: Layout,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: "/timesheet",
          name: ROUTER_PAGE_TIMESHEET,
          permission: "timesheet",
          component: Timesheet,
        },
        {
          path: "/timesheet/request-management",
          name: ROUTER_PAGE_REQUEST_MANAGEMENT,
          permission: "Request Management",
          component: RequestManagement,
        },
        {
          path: "/employee/job-info-history",
          name: "Job Info History",
          permission: "Job Info History",
          component: JobInfoHistory,
        },
        {
          path: "/timesheet/onsite-management",
          name: ROUTER_PAGE_ONSITE_MANAGEMENT,
          permission: "Onsite Management",
          component: OnsiteManagement,
        },
        {
          path: "/timesheet/overtime-management",
          name: ROUTER_PAGE_OVERTIME_MANAGEMENT,
          permission: "Overtime Management",
          component: OvertimeManagement,
        },
        {
          path: "/timesheet/overtime-management/:id",
          name: ROUTER_PAGE_OVERTIME_MANAGEMENT_DETAIL,
          permission: "Overtime Management Detail",
          component: OverTimeFlexibleDetail,
          meta: {
            isIgnore: true,
          },
        },
        {
          path: "/timesheet/explanation-management",
          name: "Explanation Management",
          permission: ExplanationMangement,
          component: ExplanationMangement,
        },
        {
          path: "/timesheet/delegation-management",
          name: ROUTER_PAGE_DELEGATION_MANAGEMENT,
          permission: "Delegation Management",
          component: DelegationManagement,
        },
        {
          path: "/timesheet/abnormal-case",
          name: ROUTER_PAGE_ABNORMAL_NOTIFICATION,
          permission: "Abnormal case",
          component: AbnormalCase,
        },
        {
          path: "/timesheet/checkin-checkout",
          name: ROUTER_PAGE_CHECKIN_CHECKOUT_time,
          permission: "Check In-Out Time",
          component: CheckInOut,
        },
        {
          path: "/timesheet/special-explanation",
          name: ROUTER_PAGE_SPECIAL_EXPLANATION,
          permission: "Special Explanation",
          component: SpecialExplanation,
        },
        // {
        //   path: "/payroll/payroll-management",
        //   name: "Payroll",
        //   permission: "Payroll",
        //   component: Payroll,
        // },
        // {
        //   path: "/payroll",
        //   name: "Payroll",
        //   permission: "Payroll",
        //   component: Payroll,
        // },
        {
          path: "/employee",
          redirect: "/employee/employee-management",
        },
        {
          path: "/employee/employee-management",
          name: ROUTER_PAGE_EMPLOYEE_MANAGEMENT,
          permission: "Employee",
          component: Employee,
        },
        {
          path: "/configuration",
          name: ROUTER_PAGE_CONFIGURATION,
          permission: "Configuration",
          component: Configuration,
        },
        {
          path: "/report",
          name: ROUTER_PAGE_REPORT,
          permission: "Report",
          component: Report,
        },
        {
          path: "/settings",
          name: ROUTER_PAGE_SETTINGS,
          redirect: "/settings/settings-config",
        },
        {
          path: "/settings/settings-config",
          name: ROUTER_PAGE_SETTING,
          component: Settings,
        },
        {
          path: "/policy-settings",
          name: ROUTER_PAGE_POLICY_SETTINGS,
          redirect: "/policy-settings/policy-management",
        },
        {
          path: "/policy-settings/policy-config",
          name: ROUTER_PAGE_POLICY_CONFIG,
          component: PolicyConfig,
        },
        {
          path: "/policy-settings/policy-config/work-schedule/create",
          name: ROUTER_PAGE_POLICY_CONFIG_CREATE,
          component: CreateEditWorkScheduleSetting,
          meta: {
            isIgnore: true,
          },
        },
        {
          path: "/policy-settings/policy-config/work-schedule/edit/:id",
          name: ROUTER_PAGE_POLICY_CONFIG_EDIT,
          component: CreateEditWorkScheduleSetting,
          meta: {
            isIgnore: true,
          },
        },
        {
          path: "/policy-settings/policy-management",
          name: ROUTER_PAGE_POLICY_MANAGEMENT,
          component: PolicyManagement,
        },
        {
          path: "/policy-settings/policy-management-employee/:id",
          name: ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY,
          component: PolicyManagementEmployeeHistory,
          meta: {
            isIgnore: true,
          },
        },
        {
          path: "/logs",
          name: ROUTER_PAGE_LOGS,
          permission: "Logs",
          component: Logs,
        },
        {
          path: "/report/detail",
          name: ROUTER_PAGE_REPORT_DETAIL,
          component: TMSReport,
          meta: {
            dependentPage: ROUTER_PAGE_REPORT,
          },
        },
        {
          path: "/report/summary",
          name: ROUTER_PAGE_REPORT_SUMMARY,
          component: TMSReport,
          meta: {
            dependentPage: ROUTER_PAGE_REPORT,
          },
        },
        {
          path: "/report/checkTime",
          name: ROUTER_PAGE_REPORT_CHECK_TIME,
          component: TMSReport,
          meta: {
            dependentPage: ROUTER_PAGE_REPORT,
          },
        },
        {
          path: "/report/policy-mapping",
          name: ROUTER_PAGE_REPORT_POLICY_MAPPING,
          component: ReportMapping,
          meta: {
            dependentPage: ROUTER_PAGE_REPORT,
          },
        },
      ],
    },
    {
      path: "/leave-management",
      name: ROUTER_PAGE_LEAVE_MANAGEMENT,
      redirect: "/leave-management/annual-leave",
      component: Layout,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: "/leave-management/annual-leave",
          name: ROUTER_PAGE_ANNUAL_LEAVE,
          permission: "Annual Leave",
          component: AnnualLeave,
        },
        {
          path: "/leave-management/project-leave",
          name: ROUTER_PAGE_PROJECT_LEAVE,
          permission: "Project Leave",
          component: ProjectLeave,
        },
        {
          path: "/leave-management/project-leave/:id",
          name: ROUTER_PAGE_PROJECT_LEAVE_DETAIL,
          permission: "Project Leave Detail",
          component: ProjectLeaveDetail,
          meta: {
            isIgnore: true,
          },
        },
      ],
    },
    {
      path: "/404",
      name: ROUTER_PAGE_PAGE_NOT_FOUND,
      component: PageNotFound,
      meta: {
        isIgnore: true,
      },
    },
    {
      path: "/:catchAll(.*)",
      redirect: "/404",
      meta: {
        isIgnore: true,
      },
    },
  ],
});

const checkPermission = (to, next, permissions) => {
  const {
    name,
    meta: { isIgnore, dependentPage },
  } = to;
  try {
    if (isIgnore || permissions?.includes(name) || permissions.includes(dependentPage)) {
      next();
    } else {
      next("/404");
    }
  } catch (error) {
    console.log(error)
  }
  
}

router.beforeEach(async (to, from, next) => {
  const { permissions } = store.state.user.userInfo;
  const sessionLogin = localStorage.getItem('session_login');
  if (!permissions && sessionLogin && to.path !== '/login') {
    const sessionObj = JSON.parse(sessionLogin)
    const res = await store.dispatch('user/getUserDetail', sessionObj.userName);
    if (res.status !== 200 || !res.data) {
      store.dispatch('user/userLogout');
      next('/login');
    } else {
      checkPermission(to, next, res.data.permissions)
    }
  } else {
    checkPermission(to, next, permissions)
  }
});
export default router;
